import { useApiStore } from "@/stores/api/index.ts";
import getDefaultOpts from "@/store/utils/getDefaultOpts.js";

const fetchRecentlyDeleted = async (module, payload = {}) => {
  const api = useApiStore();
  const { getters, commit, dispatch } = module;
  const opts = payload.opts ?? {};
  const config = Object.assign(getDefaultOpts(), opts);
  const { data } = await dispatch("httpRequest", {
    func: api.fetchRecentlyDeleted(),
    config,
  });
  const recentlyDeleted = data;

  commit("storeRecentlyDeleted", recentlyDeleted);

  return getters.recentlyDeleted();
};

export { fetchRecentlyDeleted };
